import { TimingMutationApi } from '../api/timing-mutation-api';
import { MEDIA_TRIGGER_ID_PREFIX } from '../constants';
import { TimingProps } from '../props/shape/timing-props';
import { TimingStore } from '../store/timing-store';
import { PageContext } from '../context/page-context';
import { DataModel } from './data-model';
import type { IEventManager } from '../manager/event-manager';
import type { ITimingData } from '../data';
import type { ITimingProps } from '../props/shape/timing-props';
import type { RestrictedDataModel } from './data-model';
import type { PageDataModel } from './page-data-model';

export class TimingDataModel extends DataModel<ITimingData> {
    public store: TimingStore;
    public props: ITimingProps;
    public api: TimingMutationApi;

    public constructor(
        data: ITimingData,
        events: IEventManager,
        public readonly context: PageContext,
        public parent: PageDataModel,
    ) {
        super(events);

        const newContext = PageContext.fromPageContext(context);
        newContext.setTarget(this);
        this.store = new TimingStore(data, events, this);
        this.props = new TimingProps(this.store.data, newContext);
        this.api = new TimingMutationApi(this, events, context);
    }

    public getSeqByTriggerId(triggerId: string) {
        return this.store.data.unitTimeNodeMap?.[triggerId];
    }

    public getTimeNode(triggerId: string, idx: number) {
        return this.store.data.unitTimeNodeMap?.[triggerId]?.unitTimeNodeList?.[idx];
    }

    public getMainSequence() {
        // do something
    }

    public getAllKindsOfSequence() {
        // do something
    }

    public getMediaFileInfo(mediaId: string) {
        const unitTimeNodeItem = this.store.data.unitTimeNodeMap?.[`${MEDIA_TRIGGER_ID_PREFIX}${mediaId}`];
        if (!unitTimeNodeItem) {
            return;
        }
        return unitTimeNodeItem.unitTimeNodeList?.[0];
    }
}

export { ITimingProps };
export type ITimingDataModel = RestrictedDataModel<TimingDataModel>;
